import '../sass/global.scss'; // Import SASS for processing

import { initializeParallax } from './parallax.js';
import { initializeNavigation } from '../../views/components/header/nav/component.js';

// Initialize the parallax effect
initializeParallax();
initializeNavigation();

// Navigation - Nat Toggle
document.addEventListener('DOMContentLoaded', function() {

    let nav__toggle = document.querySelector('.nav__toggle');

    let faqToggle = document.querySelector('.faq-nav__toggle--mobile');

    if(faqToggle){
        faqToggle.addEventListener('click', function() {
            toggleOptions()
          });


          document.addEventListener('click', function(e) {
            if (e.target.classList.contains("faq-option")) {
              toggleOptions()
              document.querySelector(".faq-nav__toggle--mobile").innerHTML = e.target.innerHTML;
            }

          });
    }

      nav__toggle.addEventListener('click', function() {

        document.body.classList.toggle('nav-open');

    });

});

function toggleOptions(){
  let options = document.querySelector('.faq-mobile');
  if (options) { // Ensure the element exists before accessing it
    if (options.classList.contains("hide")) {
      options.classList.remove("hide");
      options.classList.add("show");
    } else {
      options.classList.remove("show");
      options.classList.add("hide");
    }
  }
}

// -- get header__quote and assign to var
var miniCart = document.querySelector('.header__quote');

// -- on click of .cart--header cart__actions then add active class ( there is only 1 of these )

document.addEventListener('DOMContentLoaded', function() {

    let cartActions = document.getElementById('quote_toggle');

    // console.log( cartActions );

    // -- on click of cartActions add active class to miniCart
    cartActions.addEventListener('click', function(e) {

        e.preventDefault();

        miniCart.classList.toggle('active');

    });



    // -- handle press of  close-cart
    var closeCart = document.querySelectorAll('.close-cart');

    closeCart.forEach(function(closeCartButton) {

        closeCartButton.addEventListener('click', function(e) {

            miniCart.classList.remove('active');

            e.preventDefault();

        });

    });

});


document.addEventListener('DOMContentLoaded', function() {

    // -- add a JS class to the body
    document.body.classList.add('js');

});


/*
// -- Navigation - Hamburger and mobile nav
document.addEventListener('DOMContentLoaded', function() {

    // -- really for mobile only up to 1200px
    const navContainer = document.querySelector('.nav-list');
    const backLink = document.querySelector('.back-link');
    const isInTransition = false;

    // -- get .has-child and on click toggle its nav__mega then and only then add a class to the parent ul of "nav__mega--active"
    var navItems = document.querySelectorAll('.has-child');

    navItems.forEach(function(navItem) {

            if(  isInTransition ) return;

            // -- are we not on a touch device

            //if (window.matchMedia('(hover: hover)').matches) return;
            // -- lets get the first a tag and add a click event to it
            let navLink = navItem.querySelector('a');

            navLink.addEventListener('click', function(e) {

                // -- if viewport is below 1200px then do nothing
                if (window.innerWidth > 1200) return;

                e.preventDefault();

                // -- toggle the nav__mega
                let navMega = navItem.querySelector('.nav__mega');

                // -- addClass to the nav__mega if its not already there
                if( !navMega.classList.contains('nav__mega--active') ) {

                        navMega.classList.add('nav__mega--active');

                    }




                // -- toggle the nav__mega--active on the parent ul

                if( !navContainer.classList.contains('nav__mega--active') ) {

                    navContainer.classList.add('nav__mega--active');

                };



            });


    });

    backLink.addEventListener('click', function(e) {

        console.log( "hello" );

        e.preventDefault();

        // -- toggle the nav__mega--active on the parent ul
        navContainer.classList.remove('nav__mega--active');

        isInTransition = true;

        // -- after navContainer transition ends remove the nav__mega--active class from the nav__mega
        navContainer.addEventListener('transitionend', function() {



            navContainer.querySelector('.nav__mega--active').classList.remove('nav__mega--active');

            isInTransition = false;

        });

    });

});
*/


// FAQS
document.addEventListener('DOMContentLoaded', function() {



    // Get all the faq questions
    var faqQuestions = document.querySelectorAll('.faqs__item');



    // Loop through all the faq questions
    faqQuestions.forEach(function(faqQuestion) {

        // Add click event to each faq question
        faqQuestion.addEventListener('click', function() {

            // Check if the answer is visible
            if (this.classList.contains('active')) {
                // Hide the answer
                this.classList.remove('active');
            } else {
                // Show the answer
                this.classList.add('active');
            }

        });

    });

    // -- .faq-nav click / get id / toggle relevant group

    var navItems = document.querySelectorAll('.faq-nav a');

    const faqGroups = document.querySelectorAll('.faqs__group');

    navItems.forEach(function(navItem) {

            navItem.addEventListener('click', function(e) {

                e.preventDefault();

                var navId = navItem.getAttribute('href').replace('#', '');



                faqGroups.forEach(function(faqGroup) {


                    if (faqGroup.id === navId) {
                        // remove it
                        //faqGroup.remove();

                        faqGroup.classList.add('active');
                    } else {
                        faqGroup.classList.remove('active');
                    }

                });

            });

    });

    var navgroupitems = document.querySelectorAll('.nav_item');

    if(navgroupitems.length > 0){
        navItems.forEach(function(navItem) {
            navItem.classList.remove('active')
            navItem.addEventListener('click', function(e) {
                if(navItem.classList.contains('active')){
                    navItem.classList.remove('active')
                }else{
                    navItem.classList.add('active')
                }
            });
        });
    }


});


// CAROUSELS -- go in content/slick component
import Glide from '@glidejs/glide';

// -- for speed of dev all instances are init from this call - as this is bundled into the core.js
document.addEventListener('DOMContentLoaded', function() {
    // -- get all instances of .slider__slider-engine--carousel  and init Glide as a variable width slider else if its .slider__slider-engine--slideshow its just a 1 slide but done vanilla
    var carousels = document.querySelectorAll('.slider__slider-engine--carousel');
    var slideshows = document.querySelectorAll('.slider__slider-engine--slideshow');

    // -- init slideshows
    setTimeout(function() {
        slideshows.forEach(function(slideshow) {

            var glide = new Glide(slideshow, {

                perView: 1,
                animationDuration: 500,
                animationTimingFunc: 'ease-in-out',
                breakpoints: {
                    768: {
                        perView: 1
                    }
                }
            });

            glide.mount();


        });

        // -- init carousels 3 slides per view at desktop 2 at tablet and 1 at mobile
        carousels.forEach(function(carousel) {

            var glide = new Glide(carousel, {

                perView: 3,
                gap: 30,
                animationDuration: 500,
                animationTimingFunc: 'ease-in-out',
                breakpoints: {
                    1024: {
                        perView: 2
                    },
                    600: {
                        perView: 1
                    }
                }
            });

            glide.mount();

        });
    }, 1000);

    // -- .logos__carousel only needs to be glide up to 1024px then its destroyed
    var logos = document.querySelector('.glide__logos');
    let logosGlideMounted = false;

    if( logos ) {



        var logosGlide = new Glide(logos, {
            type: 'carousel',
            perView: 4,
            gap: 30,
            animationDuration: 500,
            animationTimingFunc: 'ease-in-out',
            breakpoints: {
                900: {
                    perView: 3
                },
                700: {
                    perView: 2
                },
                400: {
                    perView: 1
                }
            }
        });

        //logosGlide.mount();

        // -- window on resize if its above 1024px then destroy the glide

        window.addEventListener('resize', function() {

           doGlideInit();
           logosGlide.update();

        });

        function doGlideInit() {

            if( window.innerWidth > 1200 ) {

                if( logosGlide ) {

                    logosGlide.destroy();

                }

            } else {

                if( !logosGlideMounted ) {
                    logosGlide.mount();
                    logosGlideMounted = true;
                }

            }

        }


        doGlideInit();


    }

});


/**
 * Calls the Drupal Commerce cart endpoint to add or remove a product variation.
 *
 * @param {string} operation - Either 'add' or 'remove'.
 * @param {number} productVariationId - The ID of the product variation.
 */
function modifyCart(operation, productVariationId) {
    // Check cart limit before making the request for add operations
    if (operation === 'add') {
        const itemsCount = document.querySelector('.js-cart-items');
        const currentCount = parseInt(itemsCount?.innerText) || 0;
        
        if (currentCount >= 15) {
            showCartNotification('Product limit reached', 'Cannot add more items. Cart limit of 15 products reached.', 'error');
            return; // Exit early to prevent the request
        }
    }

    // Build the endpoint URL.
    const url = `/cart/${operation}/${productVariationId}`;

    fetch(url, {
      method: 'GET', // Our route expects a GET request. Adjust if necessary.
      credentials: 'same-origin' // Ensures cookies are sent with the request.
    })
    .then(response => {
      // If the response was a redirect, navigate the browser.
      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      return response.text();
    })
    .then(data => {
      // Optionally, process any returned data (if not a redirect).
      //   console.log('Server response:', data);
      
      try {
        const responseData = JSON.parse(data);
        
        // Check if there's an error in the response
        if (responseData.error) {
          showCartNotification('Limit Reached', responseData.error === 'Cart limit reached' 
            ? 'Cannot add more items. Cart limit of 15 products reached.' 
            : responseData.error, 'error');
          return;
        }
        
        // If it's a successful add operation
        if (operation === "add" && !responseData.error) {
          addCartDom(data);
        }
        
        // If it's a successful remove operation, hide notification if cart is under limit
        if (operation === "remove" && !responseData.error) {
          const itemsCount = document.querySelector('.js-cart-items');
          const currentCount = parseInt(itemsCount?.innerText) || 0;
          if (currentCount < 15) {
            hideCartNotification();
          }
        }
        
      } catch (e) {
        // If data is not JSON, it might be plain text or other format
        if (operation === "add") {
          addCartDom(data);
        } else if (operation === "remove") {
          // Handle remove operation for non-JSON responses
          const itemsCount = document.querySelector('.js-cart-items');
          const currentCount = parseInt(itemsCount?.innerText) || 0;
          if (currentCount < 15) {
            hideCartNotification();
          }
        }
      }
    })
    .catch(error => {
      console.error('Error modifying cart:', error);
      showCartNotification('Error', 'An error occurred while modifying the cart.', 'error');
    });
}

function addCartDom(product_data) {
    // Get current cart count
    const itemsCount = document.querySelector('.js-cart-items');
    const currentCount = parseInt(itemsCount?.innerText) || 0;
    
    // Double-check the limit before adding (in case server didn't catch it)
    if (currentCount >= 15) {
        showCartNotification('Product limit reached', 'Cannot add more items. Cart limit of 15 products reached.', 'error');
        return;
    }
    
    const productObject = JSON.parse(product_data);
    // console.log(product_data)
    
    let template = document.querySelector('.js-cart-template');
    template = template.content.firstElementChild.innerHTML;

    const keys = Object.keys(productObject);
    // console.log(keys);
    const regex = new RegExp(keys.map((key) => `{${key}}`).join('|'), 'g');

    let htmlStr = template.replace(regex, (key) => {
        key = key.replace(/{|}/g, '');
        let value = productObject[key];
        return value;
    });

    const div = document.createElement('div');
    div.innerHTML = htmlStr;

    const listContainer = document.querySelector('ul.cart');
    listContainer.appendChild(div.firstElementChild);

    // Update the cart count
    itemsCount.innerText = currentCount + 1;
    
    // Show notification if we've reached the limit
    const newCount = currentCount + 1;
    if (newCount >= 15) {
        showCartNotification('Product limit reached', 'Cannot add more items. Cart limit of 15 products reached.', 'error');
    }
}

/**
 * Shows a notification in the cart notification div
 *
 * @param {string} title - The title of the notification
 * @param {string} message - The message to display
 * @param {string} type - The type of notification ('error', 'success', etc.)
 */
function showCartNotification(title, message, type = 'info') {
    const notificationDiv = document.querySelector('.cart-notification');
    
    if (!notificationDiv) {
        console.warn('Cart notification div not found');
        return;
    }
    
    // Use the provided title and message parameters
    const notificationHTML = `
        <div class="notification notification--${type}">
            <h5 class="heading">${title}</h5>
            <div class="message">${message}</div>
        </div>
    `;
    
    // Clear any existing notifications and add the new one
    notificationDiv.innerHTML = notificationHTML;
    notificationDiv.classList.add("open"); 
}

/**
 * Hides the cart notification
 */
function hideCartNotification() {
    const notificationDiv = document.querySelector('.cart-notification');
    
    if (!notificationDiv) {
        return;
    }
    
    notificationDiv.classList.remove("open");
    // Optional: Clear the content after a delay to allow for CSS transitions
    setTimeout(() => {
        if (!notificationDiv.classList.contains("open")) {
            notificationDiv.innerHTML = '';
        }
    }, 300);
}

//Gets the users operating system for styling purposes
document.addEventListener('DOMContentLoaded', function() {
  const body = document.body;
  const platform = navigator.platform.toLowerCase();

  if (platform.includes('win')) {
    body.classList.add('windows');
  } else if (platform.includes('mac')) {
    body.classList.add('mac');
  } else if (platform.includes('linux')) {
    body.classList.add('linux');
  }
});


// CART BITSS

// -- add_to_cart on click
document.addEventListener('DOMContentLoaded', function() {

    var addToCartButtons = document.querySelectorAll('.add_to_cart');

    // console.log(addToCartButtons);
    addToCartButtons.forEach(function(addToCartButton) {

        addToCartButton.addEventListener('click', function(e) {

            // -- prevent default action
            e.preventDefault();

            // -- add class to click target to show its been added to cart
            e.target.classList.add('added-to-cart');

            // -- wait for the transition to end on the added-to-cart class
            e.target.addEventListener('transitionend', function() {
                e.target.classList.remove('added-to-cart');
                // -- change the icon to a tick by changin i class name to bx-check
                e.target.querySelector('i').className = 'bx bx-check';
                // -- now add the added-to-cart class again to show the tick
                e.target.classList.add('in-cart');

            });

            modifyCart('add', e.target.getAttribute('data-product-id'));

            // -- display the mini-cart by triggering mouse hover on .header__quote
            miniCart.classList.add('active');

        });

    });

    // -- handle click of [data-cart-id] attribute to remove from cart
    var removeFromCartButtons = document.querySelectorAll('[data-cart-id]');

    document.body.addEventListener('click', (evt) => {
        if(evt.target.dataset.cartId || evt.target.closest('[data-cart-id]')){
           let target = evt.target;
           if(!evt.target.dataset.cartId) {
              target = evt.target.closest('[data-cart-id]');
           }

           var productId = target.getAttribute('data-cart-id');

           evt.preventDefault();

           modifyCart('remove', productId);

           // -- get the cart item
           var cartItem = document.querySelector('[data-cart-id="' + productId + '"]');

           // -- remove the cart item
           if( cartItem ) {

               // -- get nearest parent of cart__item and remove it

               document.querySelector('.js-cart-items').innerText = parseInt(document.querySelector('.js-cart-items').innerText) - 1;

               cartItem.closest('.cart__item').remove();

               if(document.querySelector('.js-cart-items').innerText == 0) { 
                    history.go(0);
               }


           }
        }
    });

    document.body.addEventListener('click', (evt) => {
        if(evt.target.dataset.cartId){

        }
    });

    // removeFromCartButtons.forEach(function(removeFromCartButton) {


    //     removeFromCartButton.addEventListener('click', function(e) {

    //         // -- get the product id
    //         var productId = e.target.getAttribute('data-cart-id');

    //           // To remove product variation with ID 123:

    //         e.preventDefault();

    //         modifyCart('remove', productId);



    //         // -- get the cart item
    //         var cartItem = document.querySelector('[data-cart-id="' + productId + '"]');

    //         // -- remove the cart item
    //         if( cartItem ) {

    //             // -- get nearest parent of cart__item and remove it

    //             cartItem.closest('.cart__item').remove();




    //         }


    //     });

    // });


});




// -- Strip Stacks
// -- Refactor to have 1 function fo control all instances

document.addEventListener('DOMContentLoaded', function() {
  let articles = document.querySelectorAll('.block__article');
  let images = document.querySelectorAll('.grid__block__images img');
  let blocks = document.querySelectorAll('.headline-block');
  let block_images = document.querySelectorAll('.anim-image');

  function updateVisibility() {
      let windowHeight = window.innerHeight;

      articles.forEach((article, index) => {
          let rect = article.getBoundingClientRect();
          let visibleRatio = (windowHeight - rect.top) / (rect.bottom - rect.top);
          let isVisible = visibleRatio > 0.5;
          let id = article.getAttribute("data-block")
          let linkedImage = document.querySelector(`.grid__block__images img[data-block="${id}"]`);

          // Keep the text visible at all times (only apply opacity to the image)
          if (linkedImage) {
              linkedImage.style.opacity = isVisible ? "1" : "0";
              linkedImage.style.zIndex = id;
          }
      });

      blocks.forEach((block, index) => {
          let rect = block.getBoundingClientRect();
          let visibleRatio = (windowHeight - rect.top) / (rect.bottom - rect.top);
          let isVisible = visibleRatio > 0.5;

          // Keep the text visible at all times (only apply opacity to the image)
          if (block_images[index]) {
              block_images[index].style.opacity = isVisible ? "1" : "0";
          }
      });
  }

  // Run on load to ensure elements are visible if already in viewport
  updateVisibility();

  // Also run on scroll
  window.addEventListener('scroll', updateVisibility);
});







// [Product Specific]
document.addEventListener('DOMContentLoaded', function() {



    let galleryBuilt = false;
    const galleryActionToggle = document.querySelector('.product__gallery img');
    const galleryFullscreenToggle = document.querySelector('.full-screen');
    // -- add a blank div with a clone of the product gallery to the body
    const gallery = document.querySelector('.product__gallery');

    if( gallery ) {

        if( galleryBuilt ) return;

        // -- clone the gallery
        const galleryClone = gallery.cloneNode(true);
        galleryClone.classList.add('gallery__clone');

        // -- create a new div and append the clone to it
        var galleryWrapper = document.createElement('div');
        galleryWrapper.classList.add('gallery-modal');
        // -- add ac lose button with an event which removes the gallery-active class from the body
        var closeGallery = document.createElement('button');
        closeGallery.classList.add('close-gallery');
        closeGallery.innerHTML = '<i class="bx bx-x"></i>';
        galleryWrapper.appendChild(closeGallery);

        closeGallery.addEventListener('click', function() {

                document.body.classList.remove('gallery-active');

            });




        galleryWrapper.appendChild(galleryClone);

        // -- if we click on galleryWrapper but not the galleryClone then close the gallery
        galleryWrapper.addEventListener('click', function(e) {

            if( e.target === galleryWrapper ) {
                document.body.classList.remove('gallery-active');
            }

        });


        // get .glide from galleryClone
        var glideGalleryDiv = galleryClone.querySelector('.glide');

        document.body.appendChild(galleryWrapper);

        var galleryGlide = new Glide(glideGalleryDiv, {
            type: 'carousel',
            perView: 1,
            gap: 0,
            animationDuration: 500,
            animationTimingFunc: 'ease-in-out'
        });



        // -- aplly glide to the gallery clone
        setTimeout(function() {

            galleryGlide.mount();
            galleryGlide.update();

        }, 1000);

        galleryBuilt = true;


    }


    // -- On click lets activate the gallery
    if( galleryActionToggle ) {

        // -- loop through each galleryActionToggle and add a click event to it
        galleryActionToggle.addEventListener('click', function() {

            // -- add class to the body
            document.body.classList.add('gallery-active');

        });

    }

        // -- On click lets activate the gallery
        if( galleryFullscreenToggle ) {

            // -- loop through each galleryActionToggle and add a click event to it
            galleryFullscreenToggle.addEventListener('click', function() {

                // -- add class to the body
                document.body.classList.add('gallery-active');

            });

        }

});

document.addEventListener("DOMContentLoaded", function () {
  if ( document.getElementById("facebook-share")){
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(document.title || "Check this out!");

    document.getElementById("facebook-share").href = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    document.getElementById("twitter-share").href = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
    document.getElementById("linkedin-share").href = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;

    document.getElementById('copyButton').addEventListener('click', function(e) {
      e.preventDefault();
      const url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url)
              .then(() => {
                e.target.classList.remove('bx-link');
                e.target.classList.add('bx-check');
              })
              .catch(err => {
                  console.error('Clipboard API error:', err);
                  fallbackCopyTextToClipboard(url, e);
              });
      } else {
          fallbackCopyTextToClipboard(url, e);
      }
  });

  function fallbackCopyTextToClipboard(text, e) {
      // Create a temporary textarea element
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Ensure the textarea is not visible on screen
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);

      // Select the text and copy it
      textArea.focus();
      textArea.select();

      try {
          const successful = document.execCommand('copy');
          if (successful) {
            e.target.classList.remove('bx-link');
            e.target.classList.add('bx-check');
          } else {
              console.error('Fallback: Copy command was unsuccessful');
          }
      } catch (err) {
          console.error('Fallback: Error copying text', err);
      }

      // Remove the temporary element
      document.body.removeChild(textArea);
  }
  }

});

// Search icon
document.addEventListener("DOMContentLoaded", function () {
  let searchIcon = document.querySelector(".js-search-button");
  searchIcon.addEventListener('click', function() {
    let form = document.querySelector(".js-search-form");
    form.submit();
});

});

document.addEventListener("DOMContentLoaded", function () {
    // Select all elements with the class "items-per-page"
    var items = document.querySelectorAll(".js-items-per-page");

    // Loop through each element and add a click event listener
    items.forEach(function(item) {
      item.addEventListener("change", function (event) {
    // Create a URL object based on the current page URL.
        var currentUrl = new URL(window.location.href);

        // Update or add the 'items_per_page' parameter.
        currentUrl.searchParams.set('items_per_page', event.target.value);

        // Redirect to the updated URL.
        window.location.href = currentUrl.toString();
        // Place your click handling code here.
      });
    });
  });

document.addEventListener("DOMContentLoaded", function () {
    Drupal.behaviors.webformConfirmationEvent = {
        attach: function (context) {
            const hasConfirmation = context.querySelector('.webform-confirmation');
            if(hasConfirmation) {
                const formID = context.id
                    .replace(/-paragraph+.*/, '')
                    .replace('webform-submission-', '')
                    .replace(/-node+.*/, '')

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'form_submission',
                    'formLocation': formID
                });
            }
        }
    };
});


// Dashboard JS functionality
// Store original values for comparison and rollback
const form = document.getElementById('user-details-form');
if (form) {
    const originalValues = {};
    const updateBtn = document.getElementById('updateBtn');
    const submitBtn = document.getElementById('submitBtn');
    const cancelBtn = document.getElementById('cancelBtn');
    const successMessage = document.getElementById('successMessage');

    // Store original values when page loads
    const fields = ['firstName', 'lastName', 'position', 'landline', 'extension', 'mobile'];
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        originalValues[fieldId] = field.value;
    });

    // Handle UPDATE button click
    updateBtn.addEventListener('click', function() {
        // Enable all fields except email (readonly)
        fields.forEach(fieldId => {
            document.getElementById(fieldId).disabled = false;
        });

        // Toggle button visibility
        updateBtn.style.display = 'none';
        submitBtn.style.display = 'inline-block';
        cancelBtn.style.display = 'inline-block';

        // Focus first field
        document.getElementById('firstName').focus();
    });

    // Handle CANCEL button click
    cancelBtn.addEventListener('click', function() {
        // Restore original values
        fields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            field.value = originalValues[fieldId];
            field.disabled = true;
            field.classList.remove('field-changed');
        });

        // Toggle button visibility
        updateBtn.style.display = 'inline-block';
        submitBtn.style.display = 'none';
        cancelBtn.style.display = 'none';

        // Hide success message if visible
        successMessage.style.display = 'none';
    });

    // Add change detection to highlight modified fields
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        field.addEventListener('input', function() {
            if (this.value !== originalValues[fieldId]) {
                this.classList.add('field-changed');
            } else {
                this.classList.remove('field-changed');
            }
        });
    });

    // Handle form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Collect changed values
        const changes = {};
        const currentValues = {};
        let hasChanges = false;

        fields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            currentValues[fieldId] = field.value;
            if (field.value !== originalValues[fieldId]) {
                changes[fieldId] = {
                    old: originalValues[fieldId],
                    new: field.value
                };
                hasChanges = true;
            }
        });

        if (!hasChanges) {
            alert('No changes were made to submit.');
            return;
        }

        // Show loading state
        submitBtn.disabled = true;
        submitBtn.textContent = 'SAVING...';

        // Send AJAX request to Drupal controller
        const formData = new FormData();
        
        // Add all current values
        fields.forEach(fieldId => {
            formData.append(fieldId, currentValues[fieldId]);
        });
        
        // Add email (readonly field)
        formData.append('email', document.getElementById('email').value);
        
        // Add changes for email notification
        formData.append('changes', JSON.stringify(changes));
        formData.append('original_values', JSON.stringify(originalValues));

        // Get CSRF token (assuming it's available in drupalSettings)
        if (typeof drupalSettings !== 'undefined' && drupalSettings.csrf_token) {
            formData.append('csrf_token', drupalSettings.csrf_token);
        }

        fetch('/esc_dashboard/update-profile', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data.success) {
                // Update original values with new values
                fields.forEach(fieldId => {
                    originalValues[fieldId] = currentValues[fieldId];
                });

                // Disable fields again
                fields.forEach(fieldId => {
                    const field = document.getElementById(fieldId);
                    field.disabled = true;
                    field.classList.remove('field-changed');
                });

                // Toggle button visibility
                updateBtn.style.display = 'inline-block';
                submitBtn.style.display = 'none';
                cancelBtn.style.display = 'none';

                // Show success message
                successMessage.textContent = data.message || 'Profile updated successfully! Email notification has been sent.';
                successMessage.style.display = 'block';
                setTimeout(() => {
                    successMessage.style.display = 'none';
                }, 5000);
            } else {
                throw new Error(data.message || 'Failed to update profile');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Error updating profile: ' + error.message);
        })
        .finally(() => {
            // Reset button state
            submitBtn.disabled = false;
            submitBtn.textContent = 'SAVE CHANGES';
        });
    });
}

const companyForm = document.getElementById('company-details-form');
if (companyForm) {
    const originalValues = {};
    const updateBtn = document.getElementById('updateBtn');
    const submitBtn = document.getElementById('submitBtn');
    const cancelBtn = document.getElementById('cancelBtn');
    const successMessage = document.getElementById('successMessage');

    // Store original values when page loads
    const fields = ['companyName', 'landline', 'fax', 'addressLine1', 'addressLine2', 'addressLine3', 'townCity' , 'countyState' , 'postcode', 'country'];
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        originalValues[fieldId] = field.value;
    });

    // Handle UPDATE button click
    updateBtn.addEventListener('click', function() {
        // Enable all fields except email (readonly)
        fields.forEach(fieldId => {
            document.getElementById(fieldId).disabled = false;
        });

        // Toggle button visibility
        updateBtn.style.display = 'none';
        submitBtn.style.display = 'inline-block';
        cancelBtn.style.display = 'inline-block';

        // Focus first field
        document.getElementById('companyName').focus();
    });

    // Handle CANCEL button click
    cancelBtn.addEventListener('click', function() {
        // Restore original values
        fields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            field.value = originalValues[fieldId];
            field.disabled = true;
            field.classList.remove('field-changed');
        });

        // Toggle button visibility
        updateBtn.style.display = 'inline-block';
        submitBtn.style.display = 'none';
        cancelBtn.style.display = 'none';

        // Hide success message if visible
        successMessage.style.display = 'none';
    });

    // Add change detection to highlight modified fields
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        field.addEventListener('input', function() {
            if (this.value !== originalValues[fieldId]) {
                this.classList.add('field-changed');
            } else {
                this.classList.remove('field-changed');
            }
        });
    });

    // Handle form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Collect changed values
        const changes = {};
        const currentValues = {};
        let hasChanges = false;

        fields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            currentValues[fieldId] = field.value;
            if (field.value !== originalValues[fieldId]) {
                changes[fieldId] = {
                    old: originalValues[fieldId],
                    new: field.value
                };
                hasChanges = true;
            }
        });

        if (!hasChanges) {
            alert('No changes were made to submit.');
            return;
        }

        // Show loading state
        submitBtn.disabled = true;
        submitBtn.textContent = 'SAVING...';

        // Send AJAX request to Drupal controller
        const formData = new FormData();
        
        // Add all current values
        fields.forEach(fieldId => {
            formData.append(fieldId, currentValues[fieldId]);
        });
        
        // Add email (readonly field)
        formData.append('email', document.getElementById('email').value);
        
        // Add changes for email notification
        formData.append('changes', JSON.stringify(changes));
        formData.append('original_values', JSON.stringify(originalValues));

        // Get CSRF token (assuming it's available in drupalSettings)
        if (typeof drupalSettings !== 'undefined' && drupalSettings.csrf_token) {
            formData.append('csrf_token', drupalSettings.csrf_token);
        }

        fetch('/esc_dashboard/update-profile', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data.success) {
                // Update original values with new values
                fields.forEach(fieldId => {
                    originalValues[fieldId] = currentValues[fieldId];
                });

                // Disable fields again
                fields.forEach(fieldId => {
                    const field = document.getElementById(fieldId);
                    field.disabled = true;
                    field.classList.remove('field-changed');
                });

                // Toggle button visibility
                updateBtn.style.display = 'inline-block';
                submitBtn.style.display = 'none';
                cancelBtn.style.display = 'none';

                // Show success message
                successMessage.textContent = data.message || 'Profile updated successfully! Email notification has been sent.';
                successMessage.style.display = 'block';
                setTimeout(() => {
                    successMessage.style.display = 'none';
                }, 5000);
            } else {
                throw new Error(data.message || 'Failed to update profile');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Error updating profile: ' + error.message);
        })
        .finally(() => {
            // Reset button state
            submitBtn.disabled = false;
            submitBtn.textContent = 'SAVE CHANGES';
        });
    });
}
